import * as XLSX from 'xlsx'
import dayjs from 'dayjs'

export const exportFile = (name: string, data: any[]) => {
  /* Create worksheet */
  const ws = XLSX.utils.json_to_sheet(data)

  /* Create workbook */
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

  /* Generate XLSX file and send to client */
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(
    new Blob([XLSX.write(wb, { bookType: 'xlsx', type: 'array' })], {
      type: 'application/octet-stream',
    })
  )
  link.download = `${name} - ${dayjs().format('MMM DD, YYYY hh-mm-ssa')}.xlsx`
  link.click()
}

/*
const formatSheet = (ws: XLSX.WorkSheet, keys: string[]) => {
  // Note: The current implementation uses methods not available in xlsx
  // Commenting out incompatible code for now
  
  const headerRow = ws.getRow(1)

  for (let i = 1; i <= keys.length; i++) {
    const cell = headerRow.getCell(i)
    cell.font = { bold: true }
    cell.border = { bottom: { style: 'thin' } }
  }

  ws.columns.forEach(column => {
    column.alignment = { horizontal: 'left' }
  })

  const lastColumnLetter = columnToLetter(keys.length)
  ws.autoFilter = `A1:${lastColumnLetter}1`



const autoFitColumnWidth = (ws: XLSX.WorkSheet, minimalWidth = 0) => {
  ws.columns.forEach(column => {
    let maxColumnLength = 0
    if (column && typeof column.eachCell === 'function') {
      column.eachCell({ includeEmpty: true }, cell => {
        maxColumnLength = Math.max(
          maxColumnLength,
          minimalWidth,
          cell.value ? cell.value.toString().length : 0
        )
      })
      column.width = maxColumnLength + 2
    }
  })
  
}

const columnToLetter = (column: number) => {
  let temp,
    letter = ''
  while (column > 0) {
    temp = (column - 1) % 26
    letter = String.fromCharCode(temp + 65) + letter
    column = (column - temp - 1) / 26
  }
  return letter
}
*/
